import Tasks from './Tasks';

export type { TasksProps } from './Tasks';
export default Tasks;
